import { AfterViewInit, Component, ComponentRef, ElementRef, EventEmitter, HostListener, NgZone, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Courrier } from 'src/app/utils/interfaces/new/Courrier';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { CourriersService } from 'src/app/services/consultation/courriers/courriers.service';
import { CreateCourrier } from 'src/app/utils/interfaces/new/create-courrier.interface';
import { ConsultationService } from 'src/app/services/consultation/consultation.service';
import moment from 'moment';
import { ModalService } from 'src/app/services/modal/modal.service';
import { AutoreplaceService } from 'src/app/services/autoreplace/autoreplace.service';
import { Autoreplace } from 'src/app/utils/interfaces/new/autoreplace.interface';
import { LoginService } from 'src/app/services/login/login.service';
import { PatientService } from 'src/app/services/patient/patient.service';
import { Consultation } from 'src/app/utils/interfaces/new/consultation.interface';
import { VisualisationConsultation } from 'src/app/utils/interfaces/new/visualisation-consultation.interface';
import { DisplayDocumentService } from 'src/app/services/display-document/display-document.service';
import { DisplayDocumentComponent } from '../../display-document/display-document.component';
import { DisplayContentData } from '../../display-document/gedviewer/gedviewer.component';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { RechercheReferentielsService } from 'src/app/services/rechercheReferentiels/recherche-referentiels.service';
import { SearchInputFragment } from '../../search-input/search-input.fragment';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { ReferentielType } from '../recherche-referentiel/recherche-referentiel.component';
import { DmpInteropCode } from 'src/app/utils/interfaces/new/dmp-hl-get-interop-codes-response.interface';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { FormTemplate } from 'src/app/utils/interfaces/new/form-template.interfac';
import { DmpVisibilityEnum } from 'src/app/utils/enums/dmp-visibility.enum';
import { AddEditFragment } from '../add-edit/add-edit.fragment';
import { CpxHandleServiceAbstract, SessionTypeEnum } from 'src/app/services/cpx-handle/cpx-handle-service-abstract';
import { DmpService, envoiAutomatiqueSettingKey } from 'src/app/services/dmp/dmp.service';
import { environment } from 'src/environments/environment';
import { DmpStatusEnum, DmpUserAuthorizationEnum } from 'src/app/utils/interfaces/new/dmp-hl-get-direct-authentification-dmp-status.interface';
import { DmpFormatEnum } from 'src/app/utils/enums/dmp-format.enum';
import { DmpHlGetInteropCodesEnum } from 'src/app/utils/enums/dmp-hl-get-interop-codes-params.enum';
import { LoadingModalFragment } from '../loading/loading-modal.fragment';
import { FichePatient } from 'src/app/utils/interfaces/new/fiche-patient.interface';
import { PATIENT_MSS_ADDRESS_SUFFIX } from 'src/app/services/mss/mss-service.abstract';
import { UploadGedDocument } from 'src/app/utils/interfaces/new/UploadGEDDocument';
import { DocumentService } from 'src/app/services/document/document.service';
import { PieceJointe } from '../quick-send-mss/quick-send-mss.fragment';
import { HandleMssModalComponent, MssConnectionOk } from '../handle-mss-modal/handle-mss-modal.component';
import { MSSClinicalDocumentInfo } from 'src/app/utils/interfaces/new/mss-clinical-document-info.interface';
import { PresendClinicalDocumentModalComponent } from 'src/app/pages/user/mss/inbox/presend-clinicaldocument-modal/presend-clinicaldocument-modal.component';
import { MSSEnumTypeMail, MSSMessageToSend } from 'src/app/utils/interfaces/new/mss-message.interface';
import { MssServiceFactory } from 'src/app/services/mss/mss-service.factory';
import { EmailAuthent } from 'src/app/utils/interfaces/new/mss-email-authent.interface';
import { CpxSessionInterface } from 'src/app/utils/interfaces/new/cpx-session.interface';
import { TYPE_TO_REMOVE } from 'src/app/services/dmp/dmp-service.abstract';
import { choisirEntete, RessourceService, documentType} from 'src/app/services/ressource/ressource.service';
import { Profil } from 'src/app/utils/interfaces/new/profil.interface';
import { AddCorrespondantInEditorComponent } from '../add-correspondant-in-editor/add-correspondant-in-editor.component';
import { Correspondant } from 'src/app/utils/interfaces/new/correspondant.interface';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { CabinetService } from 'src/app/services/office/cabinet.service';
import { Destinataire } from 'src/app/utils/interfaces/new/destinataire.interface';
 import "froala-editor/js/plugins/table.min.js";
import "froala-editor/js/plugins/font_size.min.js";
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/video.min.js';
import 'froala-editor/js/plugins/quote.min.js';
import 'froala-editor/js/plugins/emoticons.min.js';
import 'froala-editor/js/plugins/special_characters.min.js';
import 'froala-editor/js/plugins/file.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/inline_class.min.js';
import 'froala-editor/js/plugins/inline_style.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/line_height.min.js';
import 'froala-editor/js/plugins/fullscreen.min.js';
import 'froala-editor/js/plugins/print.min.js';
import 'froala-editor/js/plugins/help.min.js';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/languages/fr.js';

import { FroalaEditorDirective } from 'angular-froala-wysiwyg';
import { TexteService } from 'src/app/services/texte/texte.service';
import { UserDocumentsService } from 'src/app/services/user-documents/user-documents.service';

/**
 * Interface pour les annexes à imprimer séparément
 */
export interface Annexe {
  fileName: string;
  contentType: string;
  base64Data: string;
  size: number;
}






interface NgSelectValue {
  id: string;
  libelle: string;
  meta: DmpInteropCode;
}
@Component({
  selector: 'app-edit-courrier',
  templateUrl: './edit-courrier.fragment.html',
  styleUrls: [
    './edit-courrier.fragment.scss',
    '../modal.fragment.scss'
  ],
  /**
   * Ce fragment est appelé dans une modal et ne récupère pas les modules
   * On les ajoute donc ici pour y avoir accès
   */
  providers: [
    DirectivesModule
  ]
})
export class EditCourrierFragment implements OnInit, AfterViewInit {

  public static readonly titlePrefix = 'XDM/1.0/DDM+';
  editorContent: string = '';

  // Liste des pièces jointes manuelles (ajoutées via bouton trombone)
  public manualAttachments: Array<{
    id: string;
    gedId?: string;
    title: string;
    contentType?: string;
    source?: 'patient' | 'user';
    size?: number;
  }> = [];

  public saveAttachmentsWithCourrier: boolean = false;

  editorOptions: Object = {
    pluginsEnabled: [
      'table', 'fontSize', 'fontFamily',
      'link', 'image', 'emoticons',
      'specialCharacters', 'embedly',
       'fullscreen','selectAll','help',
      'paragraphFormat', 'paragraphStyle', 'align', 'lists', 'colors', 'lineHeight', 'quote'
    ],
    fontSize: ['6','8','10', '12', '14', '16', '18', '24', '36'],
    language: 'fr',
    toolbarButtons: [
      [ 'insertTable','insertLink', 'insertImage','embedly','emoticons', 'specialCharacters', ],
      [ 'bold', 'italic', 'underline', 'strikeThrough','textColor', 'backgroundColor','clearFormatting'],
      ['fontFamily', 'fontSize', 'quote', 'paragraphFormat', 'paragraphStyle'],
      ['alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'lineHeight', 'outdent', 'indent'],
      ['undo', 'redo', 'fullscreen', 'selectAll', 'help']
    ],
    linkEditButtons: [],
    width: '100%',
    tabSpaces: 8,
    key: environment.froalaKey,
    attribution: false,
    events: {
           'image.beforeUpload': (images) => {
        const editor = this.editorInstance;
        const self = this;

        const maxSize = 500 * 1024;

        if (images.length) {
          const image = images[0];

          if (image.size > maxSize) {
            self.imageIsTooBig();
            return false;
          }

          const reader = new FileReader();
          reader.onload = (e) => {
            editor.image.insert(e.target.result, null, null, editor.image.get());
          };
          reader.readAsDataURL(image);
        }

        return false;
        }
      }
    };

  TEXT_ALD_ENCART = "<p style=\"text-align:center\">________________________________________________________________________________</p><p style=\"text-align:center\"><br></p><p style=\"text-align:center\">Prescriptions relatives au traitement de l'affection de longue durée reconnue</p><p style=\"text-align:center\">(liste ou hors liste)&nbsp;(AFFECTION EXONERANTE)</p><p style=\"text-align:center\">________________________________________________________________________________</p><p style=\"text-align:center\"><br></p><p style=\"text-align:center\">________________________________________________________________________________</p><p style=\"text-align:center\"><br></p><p style=\"text-align:center\">Prescriptions SANS RAPPORT avec l'affection de longue durée</p><p style=\"text-align:center\">(MALADIES INTERCURRENTES)</p><p style=\"text-align:center\">________________________________________________________________________________</p><p><br></p>"


  @ViewChild('froalaDrop') public froalaEditorDirective!:FroalaEditorDirective;
  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;
  @ViewChild('searchInput') public searchInput: SearchInputFragment;

  errorMessage: string;

  editorInstance: any = null;
  initControls: any = null;

  //Variables à remplir à l'appel de la modal
  newCourrier: CreateCourrier;
  courrierToEdit: Courrier;
  paitentId: string;
  consultId: string;
  courrierForm: FormGroup;

  tableName: string = 'tag';

  profil: Profil;

  isTag = true;
  isGlossaire = false;
  isPenseBete = false;
  isMaquette = false;
  isCriteres = false;
  isDossierPatient = false;
  isCourrierPerso = false;
  isMedicamentLibre = false;
  choisirEnteteParam: boolean = false;
  typeDocumentfromPreferences = null;
  typeDocumentFromTexteModele = null;
  typeDocument : string | null = null; //on stocke le type de document ici qu'on va transmettre aux composants d'envoi de mail
  autorisationEnvoiMail: boolean = true;
  
  private _initialAutoReplaceArray: Array<Autoreplace> = [];
  autoReplaceBodyTable: Paginated<Autoreplace> = {
    objects: [],
    page: 1,
    perpage: -1,
    total: 0
  };

  selectBodyTable = {
    objects: []
  };

  autoReplaceColumnTable = [
    { title: this.tableName, data: 'quickKey' }
  ];

  public courrierTypesDocuments: Array<NgSelectValue> = [];

  public documentVisibilite = Object.keys(DmpVisibilityEnum).map((v) => {
    if (isNaN(Number(v))) {
      return {
        id: DmpVisibilityEnum[v],
        libelle: v,
        disabled: false
      }
    }
  }).filter((v) => v !== undefined);

  public formTemplate: FormTemplate = {
    inputs: [
      {
        variable: 'visibilite',
        type: 'ngSelect',
        id: 'visibiliteId',
        label: 'Visibilité',
        placeholder: 'Visibilité',
        required: true,
        selectOptions: this.documentVisibilite
      },
    ],
    validators: []
  };


  @Output() public closeEmitter = new EventEmitter();


  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeAddEditModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder,
    private _courrier: CourriersService,
    private _consult: ConsultationService,
    private _modal: ModalService,
    private _view: ViewContainerRef,
    private _replace: AutoreplaceService,
    private _login: LoginService,
    private _patient: PatientService,
    private _displayDocumentSrv: DisplayDocumentService,
    private _strUtilsSrv: StringUtilsService,
    private _searchRefSrv: RechercheReferentielsService,
    private _ref: ReferentielService,
    private _dmpSrv: DmpService,
    private _documentSrv: DocumentService,
    private _loginSrv: LoginService,
    private _mssSrv: MssServiceFactory,
    private _cpxHandleSrv: CpxHandleServiceAbstract,
    private _resourceSrv: RessourceService,
    private _snakeBarSrv: SnackbarService,
    private _cabinet : CabinetService,
    private _ngZone: NgZone,
    private _texteService: TexteService,
    private _userDocumentSrv: UserDocumentsService

  ) {
    const currentProfil = this._login.getCurrentProfil();
    if (currentProfil && currentProfil.id) {
      this._dmpSrv.resourceId = currentProfil.id;
    }
  }

  ngAfterViewInit(): void {
    const checkAndUpdateFroala = () => {
      if (this.courrierToEdit && this.courrierToEdit.courrierText && this.froalaEditorDirective) {
        this.editorContent=this.courrierToEdit.courrierText;
      } else if (this.newCourrier && this.newCourrier.courrierText && this.froalaEditorDirective) {
        this.editorContent=this.newCourrier.courrierText;
      }
    };

    const intervalId = setInterval(() => {
      if (this.froalaEditorDirective) {
        checkAndUpdateFroala();
        clearInterval(intervalId);
      }
    }, 100);

    // Timeout pour ne pas vérifier indéfiniment
    setTimeout(() => clearInterval(intervalId), 5000);
  }

  /**
   * Initialisation de l'éditeur pour accéder aux méthodes de froala pour cibler l'éditeur, pour le drag and drop
   * @param initControls
   */
  initialize(initControls: any) {
    this.initControls = initControls;
    this.initControls.initialize();

    setTimeout(() => {
      this.editorInstance = this.initControls.getEditor();
      this.attachEditorLinkHandlers();
    });
  }

  async ngOnInit(): Promise<void> {

    let villeDateParam;
    let nomPatientParam;
    let enteteVideParam;
    let piedVideParam;
    let duplicataParam;
    let duplicataPatientParam;
    let retenueEnvoiDmpParam;


    const currentFichePatient= await this._patient.findOnePatientFiche(this.paitentId);

    if(currentFichePatient && currentFichePatient.mssProConsentement === false &&
   (!currentFichePatient.ins || !currentFichePatient.insKey
   || currentFichePatient.identiteStatutId !== '95a6081f-5260-44b8-9661-e4795e1cfcaf')){
    this.autorisationEnvoiMail = false;
    }
    await this.initListTypeDocument()

    this.autoReplaceBodyTable.objects = await this.getListByName(this.tableName);
    this._initialAutoReplaceArray = this.autoReplaceBodyTable.objects;

    const currentProfilStr = localStorage.getItem('currentProfil');
    if (currentProfilStr && currentProfilStr !== '') {
      const currentProfil = JSON.parse(currentProfilStr);
      this.profil = currentProfil as Profil;
      //on récupère les préférences de l'utilisateur
      const params = await this._resourceSrv.getResourceSettings(this.profil.id, 'profil');

      if (params) {
        const villeDate = params.find(setting => setting.settingKey === 'villeDate');
          if (villeDate){
            villeDateParam = JSON.parse(villeDate.settingValue);
          }else{
            villeDateParam = false;
          }

        const nomPatient = params.find(setting => setting.settingKey === 'nomPatient') ;
          if (nomPatient){
            nomPatientParam = JSON.parse(nomPatient.settingValue);
          }else{
            nomPatientParam = false;
          }

        const enteteVide = params.find(setting => setting.settingKey === 'enteteVide') ;
          if (enteteVide){
            enteteVideParam = JSON.parse(enteteVide.settingValue);
          }else{
            enteteVideParam = false;
          }

        const piedVide = params.find(setting => setting.settingKey === 'piedVide') ;
          if (piedVide){
            piedVideParam = JSON.parse(piedVide.settingValue);
          }else{
            piedVideParam = false;
          }

        const duplicata = params.find(setting => setting.settingKey === 'duplicata') ;
          if (duplicata){
            duplicataParam = JSON.parse(duplicata.settingValue);
          }else{
            duplicataParam = false;
          }

        const duplicataPatient = params.find(setting => setting.settingKey === 'duplicataPatient') ;
          if (duplicataPatient){
            duplicataPatientParam = JSON.parse(duplicataPatient.settingValue);
          }else{
            duplicataPatientParam = false;
          }

        const retenueEnvoiDmp = params.find(setting => setting.settingKey === 'retenueEnvoiDmp') ;
          if (retenueEnvoiDmp) {
            retenueEnvoiDmpParam = JSON.parse(retenueEnvoiDmp.settingValue);
          } else {
            retenueEnvoiDmpParam = true;
          }
        const activerChoisirEntete = params.find(setting => setting.settingKey === choisirEntete) ;
          if (activerChoisirEntete){
            this.choisirEnteteParam= JSON.parse(activerChoisirEntete.settingValue);
          }else{
            this.choisirEnteteParam = false;
          }
           const documentTypeSetting = params.find(p => p.settingKey === documentType);
          if (documentTypeSetting){
            this.typeDocumentfromPreferences= documentTypeSetting.settingValue;
          }else{
            this.typeDocumentfromPreferences = null;
          }
    }

  if (this.courrierToEdit) {
    await this.getTypeDocumentFromTexteModele(this.courrierToEdit);
    const typeDoc: string | null = this.getdocumentTypeLibelle();

      this.courrierForm = this._formBuilder.group({
        titre: [this.courrierToEdit.titre, [Validators.required, Validators.maxLength(128)]],
        isVilleDate: [this.courrierToEdit.isVilleDate],
        isNomPatient: [this.courrierToEdit.isNomPatient ],
        isSelectCorrespondant: [this.courrierToEdit.isSelectCorrespondant],
        isImpressionPatient: [this.courrierToEdit.isImpressionPatient],
        isEnteteVide: [this.courrierToEdit.isEnteteVide ],
        isPiedVide: [this.courrierToEdit.isPiedVide ],
        isDuplicata: [this.courrierToEdit.isDuplicata],
        typeDocument: [typeDoc],
        annuleEtRemplace: [true],
        retenueEnvoiDmp: [this.courrierToEdit.retenueEnvoiDmp ?? true],
        motifRetenueEnvoiDmp: [this.courrierToEdit.motifRetenueEnvoiDmp || ''],
      })
    } else if (this.newCourrier) {
      await this.getTypeDocumentFromTexteModele(this.newCourrier)
      const typeDoc: string | null = this.getdocumentTypeLibelle();

      this.courrierForm = this._formBuilder.group({
        titre: [this.newCourrier.titre, [Validators.required, Validators.maxLength(128)]],
        isVilleDate: [villeDateParam],
        isNomPatient: [nomPatientParam ],
        isSelectCorrespondant: [this.newCourrier.isSelectCorrespondant],
        isImpressionPatient: [duplicataPatientParam ],
        isEnteteVide: [enteteVideParam],
        isPiedVide: [piedVideParam ],
        isDuplicata: [duplicataParam],
        typeDocument: [typeDoc],
        annuleEtRemplace: [false],
        retenueEnvoiDmp: [retenueEnvoiDmpParam ],
        motifRetenueEnvoiDmp: [this.newCourrier.motifRetenueEnvoiDmp || ''],
      });
    }
    this.handleTypeDocumentValidation();

  }
  }


 async getTypeDocumentFromTexteModele(courrier: Courrier | CreateCourrier): Promise<string | null> {
  if (courrier?.idTexteModele) {
    const texteModele = await this._texteService.findOneTexte(courrier.idTexteModele);
    if (texteModele?.documentType) {
      this.typeDocumentFromTexteModele = texteModele.documentType;
      return this.typeDocumentFromTexteModele;
    }
  }
  return null;
}

getdocumentTypeLibelle(): string | null {
  if (this.typeDocumentFromTexteModele) {
    const matchingOption = this.courrierTypesDocuments.find(
      t => t.meta.s_code === this.typeDocumentFromTexteModele
    );
    if (matchingOption) {
      this.typeDocument = this.typeDocumentFromTexteModele;
      return matchingOption.id;
    }
  }
  if (this.typeDocumentfromPreferences) {
    const matchingOption = this.courrierTypesDocuments.find(
      t => t.meta.s_code === this.typeDocumentfromPreferences
    );
    if (matchingOption) {
      this.typeDocument = this.typeDocumentfromPreferences;
      return matchingOption.id;
    }
  }
  this.typeDocument = null;
  return null;
}



  private handleTypeDocumentValidation(): void {
    this.courrierForm.get('retenueEnvoiDmp')?.valueChanges.subscribe((value: boolean) => {
      const typeDocumentControl = this.courrierForm.get('typeDocument');
      if (value) {
        typeDocumentControl?.clearValidators();
      } else {
        typeDocumentControl?.setValidators([Validators.required]);
      }
      typeDocumentControl?.updateValueAndValidity();
    });


  }

public imageIsTooBig(): void {
  this._ngZone.run(() => { // Utilisation de NgZone pour s'assurer que le snackbar est affichée dans le DOM principal sinon elle s'affiche sur la toolbar
    this._snakeBarSrv.openSnackBarError('L’image dépasse la taille maximale autorisée de 500 Ko.');
  });
}


  private async initListTypeDocument(): Promise<void> {
    const typeDocumentArrTmp = await this._ref.findRefListTableHypermed(ReferentielEnum.typecode_dmp);
    for (const typeD of typeDocumentArrTmp) {
      this.courrierTypesDocuments.push({
        id: typeD.id,
        libelle: typeD.libelle,
        meta: {
          s_code: typeD.id.split('++')[0],
          s_displayName: typeD.libelle,
          s_codeSystem: typeD.sublibelle,
        }
      })
    }
    this.courrierTypesDocuments.sort((a, b) => {
      return a.libelle.localeCompare(b.libelle);
    });

    // On supprime les types "impossibles"
    this.courrierTypesDocuments = this.courrierTypesDocuments.filter((typeD) => {
      return !TYPE_TO_REMOVE.includes(typeD.meta.s_code);
    });
  }

  public closeAddEditModal(object?: any): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit(null);
    }
  }

  private _loading: ComponentRef<LoadingModalFragment> | undefined = undefined;
  private async _displayLoading(doDisplay: boolean): Promise<void> {
    if (doDisplay && !this._loading) {
      this._loading = this._modal.openLoading(this._view);
    } else if (!doDisplay && this._loading) {
      this._loading.destroy();
      this._loading = undefined;
    }
  }

  private async _getDmpSession(): Promise<CpxSessionInterface | undefined> {
    const useCert = await this._cpxHandleSrv.isESConnexionIndirect(SessionTypeEnum.CERT_DMP);
    const typeSession = useCert ? SessionTypeEnum.CERT_DMP : SessionTypeEnum.CARTE;
    let rtd: CpxSessionInterface | undefined = undefined;
    if (this._cpxHandleSrv.isSessionOpen(typeSession)) {
      rtd = await this._cpxHandleSrv.getCpxSession(this._view, typeSession);
    }

    if (rtd && rtd.practiceSettingIndice !== undefined && rtd.practiceSettingIndice !== null) {
      return rtd;
    } else if (rtd && (rtd.practiceSettingIndice === undefined || rtd.practiceSettingIndice === null)) {
      await this._cpxHandleSrv.closeSession(SessionTypeEnum.CARTE);
      return await this._getDmpSession();
    } else {
      return undefined;
    }
  }

  private async _autoSendDmp(courrierId: string, courrier: CreateCourrier): Promise<void> {
    if (courrier.retenueEnvoiDmp) {
      return;
    }

    const _confirmSending = async (): Promise<boolean> => {
      return new Promise(async (resolve, _) => {
        const modal = this._modal.openModalConfirmation(
          this._view,
          'Envoi automatique au DMP',
          "Ce type de document peut être envoyé automatiquement sur le DMP du patient.\nVoulez-vous l'envoyer ?\n\n(Pour envoyer le document sur le DMP il vous faudra indiquer la visibilité du document dans le formulaire suivant)"
        );
        const sub = modal.instance.closeEmitter.subscribe(async (res) => {
          resolve(res);
          sub.unsubscribe();
        });
      });
    };

    const _isCardCpxPresent = async (): Promise<boolean> => {
      return new Promise<boolean>(async (resolve, _) => {
        /**
         * On test la présence d'une carte CPx dans le lecteur.
         * Si une carte est présente on renvoie true
         * Sinon, DmpConnectJS2 renvoi une erreur, on passe donc dans le catch
         * à ce moment on renvoie false (pas de carte CPx présente dans le lecteur)
         */
        try {
          await this._cpxHandleSrv.lectureCpxCard();
          resolve(true);
        } catch (e) {
          this._snakeBarSrv.openSnackBarError("Envoi au DMP impossible : La carte CPS est absente ou n'a pas pu être lue.");
          console.error("Erreur de lecture de la carte CPS : ", e);
          resolve(false);
        }
      });
    };

    const _askConnexionSecrete = async (): Promise<void> => {
      return new Promise<void>((async (resolve, reject) => {
        try {
          const modal = this._modal.openModalConfirmation(
            this._view,
            'Connexion secrète',
            `Le patient est mineur, voulez-vous accéder à son DMP en mode connexion secrète ?\n\nLe mode connexion secrète ne laisse pas de trace d'accès visible pour les représentants légaux et permet ainsi de protéger le secret des mineurs.`
          );
          const sub = modal.instance.closeEmitter.subscribe(async (res) => {
            if (res) {
              await this._dmpSrv.setConfidentialityLevel(this._view, res);
            }
            resolve();
            sub.unsubscribe();
          });
        } catch (e) {
          console.error("Erreur lors de la demande de connexion secrète", e);
          this._snakeBarSrv.openSnackBarError("Erreur lors de la connexion secrète.")
          reject(e);
        }
      }));
    };

    const _getDmpSession = async (): Promise<CpxSessionInterface | undefined> => {
      const useCert = await this._cpxHandleSrv.isESConnexionIndirect(SessionTypeEnum.CERT_DMP);
      const typeSession = useCert ? SessionTypeEnum.CERT_DMP : SessionTypeEnum.CARTE;
      let rtd: CpxSessionInterface | undefined = undefined;
      if (this._cpxHandleSrv.isSessionOpen(typeSession)) {
        rtd = await this._cpxHandleSrv.getCpxSession(this._view, typeSession);
      }

      if (rtd && rtd.practiceSettingIndice !== undefined && rtd.practiceSettingIndice !== null) {
        return rtd;
      } else if (rtd && (rtd.practiceSettingIndice === undefined || rtd.practiceSettingIndice === null)) {
        await this._cpxHandleSrv.closeSession(SessionTypeEnum.CARTE);
        return await this._getDmpSession();
      } else {
        this._snakeBarSrv.openSnackBarError("Aucune session DMP trouvée ou authentification requise.");
        console.error("Aucune session DMP trouvée ou authentification requise.");
        return undefined;
      }
    };

    return new Promise<void>(async (resolve, reject) => {
      try {
        this._displayLoading(true);
        const isCpxPresent = await _isCardCpxPresent();
        if (!isCpxPresent) {
          /**
           * Pour le moment, si aucune catye CPx n'est présente dans le lecteur,
           * nous ne faisons que resolve et return pour sortir de la méthode.
           *
           * À terme, il faudra générer le document et l'enregistrer dans une liste
           * en attente d'envoi au DMP (Segur 2).
           *
           * TODO Génération du document et enregistrement en liste d'attente
           */

          resolve();
          return;
        }
      } catch (e) {
        console.error(e);
        this._snakeBarSrv.openSnackBarError("Erreur lors de la vérification de la carte CPx", e);
        return
      } finally {
        this._displayLoading(false);
      }

      try {
        const session = await _getDmpSession();
        if (!session) {
          resolve();
          return;
        }
        // On vérifie que le patient ait un statut d'identité qualifié
        this._displayLoading(true);
        // On passe la confidentialité à false pour réinitialiser le confidentiality-code des appels DMP
        await this._dmpSrv.setConfidentialityLevel(this._view, false);

        const patient = await this._getPatientIfQualifie();
        // patient.dateNaissance = moment('2015-03-04', 'YYYY-MM-DD').format('YYYY-MM-DD');
        const dmpParams = await this._dmpSrv.getDmpParameters(this._view);
        if (patient && patient.dateNaissance && dmpParams.minorFunctionManagement && dmpParams.majorityAge && moment(new Date()).subtract(dmpParams.majorityAge, 'year').isBefore(moment(patient.dateNaissance, 'YYYY-MM-DD'))) {
          await _askConnexionSecrete();
        }
        if (patient) {
          const typeDocument = this.courrierTypesDocuments.find((typeD) => typeD.id === this.courrierForm.controls['typeDocument'].value);
            // On vérifie le statut du DMP patient
            this._displayLoading(true);
            if (!await this._getDmpSession()) {
              resolve();
              return;
            }
            const patientDmp = await this._dmpSrv.hl_getdirectauthentificationdmpstatus(this._view, `${patient.ins}${patient.insKey}${environment.dmpInsSuffix as 'D' | 'T' | 'N'}`);
            this._displayLoading(false);
            if (patientDmp && patientDmp.ExistingTestAnswer.i_dmpStatus === DmpStatusEnum['DMP existant']
              && (patientDmp.ExistingTestAnswer.i_userAuthorization === DmpUserAuthorizationEnum.AuthorizationExist)
            ) {

              if (!await _confirmSending()) {
                resolve();
                return;
              }

              // Pour envoyer dans le DMP automatiquement nous devons demander la visibilité du document
              // const modalAlert = this._modal.openAlert(this._view, "Envoi automatique au DMP",
              //   "Ce type de document doit être envoyé automatiquement via le DMP veuillez confirmer la visibilité du document");
              // await new Promise<void>((r, _) => {
              //   const sub = modalAlert.instance.closeEmitter.subscribe(async (res) => {
              //     sub.unsubscribe();
              //     r();
              //   });
              // });

              const confidentialityLevel = await this._dmpSrv.getConfidentialityLevel(this._view);
              for (const v of this.documentVisibilite) {
                if (confidentialityLevel && (
                  v.id === DmpVisibilityEnum["Le document est visible de tous"] as any
                  || v.id === DmpVisibilityEnum["Le document n'est pas visible pour le patient"] as any
                  || v.id === DmpVisibilityEnum["Le document n'est pas visible pour les doctors de santé"] as any
                )) {
                  v.disabled = true;
                }
              }

              const modaleVisibilite = this._modal.openModalAddEdit('Visibilité du document', this._view, this.formTemplate, true);
              modaleVisibilite.instance.dismissable = false;
              const dmpVisibility = await new Promise<any>((r, _) => {
                // Close emiter pour toutes les modales :cry: TODO
                const sub = this._modal.closeEmitter.subscribe(async (res) => {
                  sub.unsubscribe();
                  if (res && res.loadingModal) {
                    (res.loadingModal as ComponentRef<LoadingModalFragment>).destroy();
                  }
                  if (res && res.addEditFragment) {
                    (res.addEditFragment as ComponentRef<AddEditFragment>).destroy();
                  }
                  if (res?.object?.visibilite) {
                    r(res.object.visibilite);
                  } else {
                    r(undefined);
                  }
                });
              });

              if (dmpVisibility) {
                this._displayLoading(true);

                // On génère la base 64 du courrier
                const base64 = await this._courrier.convertToPdf(courrier, undefined, this._fichePatient);
                const cleanBase64 = base64.split('base64,')[1];

                // ///////////////////////
                const newDoc: any = {
                  contentType: 'application/pdf',
                  documentAssocieId: courrierId,
                  file: base64,
                  fileName: `${courrier.titre}.pdf`,
                  size: atob(base64.substring(base64.indexOf(',') + 1)).length
                };

                const uploadFile: UploadGedDocument = {
                  content: newDoc.file,
                  fileName: newDoc.fileName,
                  mime: newDoc.contentType
                };
                const documentGEDId = await this._documentSrv.uploadFile(uploadFile);

                let existingDocument;
                existingDocument = await this._documentSrv.getDocumentByDocumentAssocieId(newDoc.documentAssocieId);

                if (existingDocument) {
                  await this._documentSrv.updateDocument(
                    existingDocument.id,
                    {
                      contentType: newDoc.contentType,
                      fileName: newDoc.fileName,
                      gedId: documentGEDId,
                      titre: courrier.titre,
                      typeId: "b98d0840-13c5-44ef-a927-99610bb9174a", // correspond à autre dans référentiel général
                      consultationId: this.consultId,
                      authorId: this._loginSrv.getCurrentProfil().id,
                      weight: newDoc.size,
                      documentAssocieId: newDoc.documentAssocieId,
                      typeDocumentAssocie: newDoc.typeDocumentAssocie,
                    },
                    true
                  );
                } else {
                  await this._documentSrv.createDocument(
                    patient.id,
                    {
                      contentType: newDoc.contentType,
                      fileName: newDoc.fileName,
                      gedId: documentGEDId,
                      titre: courrier.titre,
                      typeId: "b98d0840-13c5-44ef-a927-99610bb9174a", // correspond à autre dans référentiel général
                      consultationId: this.consultId,
                      authorId: this._loginSrv.getCurrentProfil().id,
                      weight: newDoc.size,
                      documentAssocieId: newDoc.documentAssocieId,
                      typeDocumentAssocie: newDoc.typeDocumentAssocie,
                    }
                  );
                }
                // ///////////////////////

                // On peut désormais envoyer le document sur le DMP
                await this._dmpSrv.hl_senddocument(
                  this._view,
                  {
                    s_healthcareSetting: '',
                    s_ins: {
                      s_ins: `${patient.ins}${patient.insKey}`,
                      s_insType: environment.dmpInsSuffix as 'D' | 'T' | 'N'
                    },
                    s_birthPlaceCode: patient.cpNaissance,
                  }, {
                  EventCodes: undefined,
                  i_format: DmpFormatEnum['Document au format PDF'],
                  i_visibility: (DmpVisibilityEnum[dmpVisibility] as unknown) as DmpVisibilityEnum,
                  s_category: typeDocument.meta.s_code as DmpHlGetInteropCodesEnum,
                  s_contentInBase64: cleanBase64,
                  s_creationDate: moment().toDate(),
                  s_description: '',
                  s_formatCode: undefined,
                  s_serviceStartDate: undefined,
                  s_serviceStopDate: undefined,
                  s_title: courrier.titre + '.pdf'
                },
                  courrierId,
                  patient.id
                );

                this._snakeBarSrv.openSnackBarSuccess("Envoi au DMP réussi.");
              }
            } else {
              this._snakeBarSrv.openSnackBarError("Envoi au DMP impossible: Le DMP n'est pas accessible.");
              console.error("DMP inaccessible.")
            }
        }
        resolve();
      } catch (e) {
        console.error('Erreur lors de l\'envoi au DMP:', e);
        this._snakeBarSrv.openSnackBarError("Erreur lors de l'envoi au DMP.");
        reject(e);
      } finally {
        this._displayLoading(false);
      }
    });
  }

  private async _autoSendMssPatient(courrierId: string, courrier: CreateCourrier): Promise<void> {
    const _initMss = async (): Promise<EmailAuthent> => {
      return new Promise<EmailAuthent>(async (resolve) => {
        const modal = this._modal.openModal<HandleMssModalComponent>(
          this._view, HandleMssModalComponent
        ) as ComponentRef<HandleMssModalComponent>;
        const sub = modal.instance.closeEmitter.subscribe((res: MssConnectionOk | undefined) => {
          sub.unsubscribe();
          modal.destroy();
          if (res) {
            this._mssSrv.switchService(res.provider);
          }
          resolve(res && res.email && res.email !== '' && res.idNat && res.idNat !== '' ? res : undefined);
        });
      });
    };

    return new Promise<void>(async (resolve, reject) => {
      try {
        this._displayLoading(true);
        const patient = await this._getPatientIfQualifie();
        this._displayLoading(false);
        if (patient && patient.mssPatientConsentement) {
          const modalAlert = this._modal.openAlert(this._view, "Envoi automatique à la MSS Patient",
            "Ce document doit être envoyé sur la MSS Patient.\nAprès votre connexion à la MSS, vous devrez renseigner les informations nécessaires à l'envoi du document.");
          await new Promise<void>((r, _) => {
            const sub = modalAlert.instance.closeEmitter.subscribe(async (res) => {
              sub.unsubscribe();
              r();
            });
          });

          // On ouvre une connexion MSS
          const emailAuthent = await _initMss();
          if (emailAuthent) {
            const patientMssAddress = `${patient.ins}${PATIENT_MSS_ADDRESS_SUFFIX}`;
            this._displayLoading(true);
            const base64 = await this._courrier.convertToPdf({ ...courrier }, {
              to: [patientMssAddress]
            }, this._fichePatient);

            const pj: PieceJointe = {
              clinicalDocument: true,
              contentType: 'application/pdf',
              documentAssocieId: courrierId,
              file: base64,
              fileName: `${courrier.titre}.pdf`,
              size: atob(base64.substring(base64.indexOf(',') + 1)).length
            };

            const uploadFile: UploadGedDocument = {
              content: pj.file,
              fileName: pj.fileName,
              mime: pj.contentType
            };
            const documentGEDId = await this._documentSrv.uploadFile(uploadFile);

            let existingDocument;
            existingDocument = await this._documentSrv.getDocumentByDocumentAssocieId(pj.documentAssocieId);

            if (existingDocument) {
              await this._documentSrv.updateDocument(
                existingDocument.id,
                {
                  contentType: pj.contentType,
                  fileName: pj.fileName,
                  gedId: documentGEDId,
                  titre: courrier.titre,
                  typeId: "b98d0840-13c5-44ef-a927-99610bb9174a", // correspond à autre dans référentiel général
                  consultationId: this.consultId,
                  authorId: this._loginSrv.getCurrentProfil().id,
                  weight: pj.size,
                  documentAssocieId: pj.documentAssocieId,
                  typeDocumentAssocie: pj.typeDocumentAssocie,
                },
                true
              );
            } else {
              await this._documentSrv.createDocument(
                patient.id,
                {
                  contentType: pj.contentType,
                  fileName: pj.fileName,
                  gedId: documentGEDId,
                  titre: courrier.titre,
                  typeId: "b98d0840-13c5-44ef-a927-99610bb9174a", // correspond à autre dans référentiel général
                  consultationId: this.consultId,
                  authorId: this._loginSrv.getCurrentProfil().id,
                  weight: pj.size,
                  documentAssocieId: pj.documentAssocieId,
                  typeDocumentAssocie: pj.typeDocumentAssocie,
                }
              );
            }

            let subject = courrier.titre;
            if (!courrier.titre.startsWith(EditCourrierFragment.titlePrefix)) {
              subject = `${EditCourrierFragment.titlePrefix}${subject} ${this._fichePatient.nom} ${this._fichePatient.prenom} ${this._fichePatient.dateNaissance}`;
            }

            const message: MSSMessageToSend = {
              messageData: {
                addresses: [{ email: emailAuthent.email, type: MSSEnumTypeMail.TO }, { email: emailAuthent.email, type: MSSEnumTypeMail.FROM }],
                attachments: [pj],
                body: courrier.courrierText,
                subject,
                isHtml: true
              },
              patientInfo: {
                birthDate: this._fichePatient.dateNaissance,
                couverture: {
                  ins: this._fichePatient.ins,
                  insKey: this._fichePatient.insKey,
                  oid: this._fichePatient.oid
                },
                firstName: this._fichePatient.prenom,
                lastName: this._fichePatient.nom,
                patientId: this.paitentId
              }
            };

            let askForClinicalInfo;
            if (message.messageData.attachments.length === 1 && message.messageData.attachments[0].clinicalDocument) {
              this._displayLoading(false);
              // On essaye d'envoyer le message en mode clinical document
              askForClinicalInfo = await new Promise<MSSClinicalDocumentInfo | undefined>(async (r, reject) => {
                try {
                  const modal = this._modal.openModal<PresendClinicalDocumentModalComponent>(
                    this._view,
                    PresendClinicalDocumentModalComponent
                  ) as ComponentRef<PresendClinicalDocumentModalComponent>;

                  const initOverSub = modal.instance.initOverEmitter.subscribe(() => {
                    initOverSub.unsubscribe();
                    modal.instance.setDocTitle(message.messageData.attachments[0].fileName);
                    if (this.courrierForm && this.courrierForm.controls && this.courrierForm.controls['typeDocument'] && this.courrierForm.controls['typeDocument'].value) {
                      modal.instance.setDocType(this.courrierForm.controls['typeDocument'].value);
                    }
                    modal.instance.setDocFormat('urn:ihe:iti:xds-sd:pdf:2008');
                    modal.instance.setNonEditableFields(['titreDocument', 'typeDocument', 'formatDocument']);
                  });
                  const sub = modal.instance.closeEmitter.subscribe((infos?: MSSClinicalDocumentInfo) => {
                    r(infos);
                    modal.destroy();
                    sub.unsubscribe();
                  });
                } catch (e) {
                  reject(e);
                }
              });
              this._displayLoading(true);
              message.clinicalDocumentInfo = askForClinicalInfo;
              try {
                await this._mssSrv.getService().sendMessage(
                  { email: emailAuthent.email, idNat: emailAuthent.idNat },
                  message,
                  askForClinicalInfo
                );
                resolve();
              } catch (e) {
                console.error('[autoSendMssPatient] Erreur lors de sendMessage :', e);
                reject(e);
              } finally {
                this._displayLoading(false);
              }
              this._snakeBarSrv.openSnackBarSuccess("Message bien envoyé sur la MSS Patient.");
            } else {
              this._displayLoading(true);
              message.clinicalDocumentInfo = askForClinicalInfo;
              // On envoi le message
              await this._mssSrv.getService().sendMessage(
                { email: emailAuthent.email, idNat: emailAuthent.idNat },
                message
              );
              this._displayLoading(false);
              this._snakeBarSrv.openSnackBarSuccess("Message bien envoyé sur la MSS Patient.");
              resolve();
            }
            resolve();
          }
          resolve();
        }
        resolve();
      } catch (e) {
        console.error('[autoSendMssPatient] Erreur catchée :', e);
        reject(e);
        this._displayLoading(false);
      }
    });
  }

  private _fichePatient: FichePatient | undefined = undefined;
  private async _getPatientIfQualifie(): Promise<FichePatient | undefined> {
    return new Promise<FichePatient | undefined>(async (resolve, reject) => {
      this._displayLoading(true);
      try {
        if (this._fichePatient) {
          if (this._fichePatient && this._fichePatient.identiteStatutId === '95a6081f-5260-44b8-9661-e4795e1cfcaf'
            && this._fichePatient.ins && this._fichePatient.ins !== '' && this._fichePatient.insKey && this._fichePatient.insKey !== '') {
            resolve(this._fichePatient);
            return;
          } else {
            resolve(undefined);
            return;
          }
        }

        const patient = await this._patient.findOnePatientFiche(this.paitentId);
        if (patient && patient.identiteStatutId === '95a6081f-5260-44b8-9661-e4795e1cfcaf'
          && patient.ins && patient.ins !== '' && patient.insKey && patient.insKey !== '') {
          this._fichePatient = patient;
          resolve(this._fichePatient);
        } else {
          resolve(undefined);
        }
      } catch (e) {
        console.error(e);
        reject(e);
      } finally {
        this._displayLoading(false);
      }
    });
  }

  async saveCourrier(saveAndClose?: boolean) {
    const _getNewCourrier = async (isUpdate: boolean): Promise<CreateCourrier> => {
      let annuleEtRemplace = false;
      let versionCourrier = 1;
      let titre = this.courrierForm?.controls?.['titre']?.value || '';

      const patient = await this._getPatientIfQualifie();
      const type = this.courrierForm?.controls?.['typeDocument']?.value ? this.courrierTypesDocuments.find(t => t.id === this.courrierForm?.controls?.['typeDocument']?.value)?.libelle : undefined
      if (patient && type) {
        titre = `${moment().format('DD-MM-YYYY')}_${type}_${this._fichePatient.nom}_${this._fichePatient.prenom}`;
      }

      if (isUpdate && this.courrierForm?.controls?.['annuleEtRemplace']?.value) {
        if (this.courrierForm?.controls?.['annuleEtRemplace']?.value) {
          annuleEtRemplace = true;
        }

        if (annuleEtRemplace && titre.indexOf("Annule et remplace : ") === -1) {
          titre = "Annule et remplace : " + titre;
        }

        if (this.courrierToEdit && this.courrierToEdit.versionCourrier) {
          versionCourrier = (this.courrierToEdit.versionCourrier ?? 1) + 1;
        }
      }

      const rtd: CreateCourrier = {
        idConsultation: this.consultId,
        titre,
        courrierText: this.editorContent || '',
        isDuplicata: this.courrierForm.controls['isDuplicata'].value,
        isEnteteVide: this.courrierForm.controls['isEnteteVide'].value,
        isImpressionPatient: this.courrierForm.controls['isImpressionPatient'].value,
        isNomPatient: this.courrierForm.controls['isNomPatient'].value,
        isPiedVide: this.courrierForm.controls['isPiedVide'].value,
        isSelectCorrespondant: this.courrierForm.controls['isSelectCorrespondant'].value,
        isVilleDate: this.courrierForm.controls['isVilleDate'].value,
        annuleEtRemplace,
        versionCourrier,
        retenueEnvoiDmp: this.courrierForm.controls['retenueEnvoiDmp'].value,
        motifRetenueEnvoiDmp: this.courrierForm.controls['retenueEnvoiDmp'].value ? this.courrierForm.controls['motifRetenueEnvoiDmp'].value : '',
        idTexteModele: this.newCourrier ? this.newCourrier.idTexteModele : this.courrierToEdit ? this.courrierToEdit.idTexteModele : undefined,
      };

      return rtd;

    };

    const courrierToCreateCourrier = (courrier: Courrier): CreateCourrier => {
      return {
        idConsultation: courrier.consultation.id,
        titre: courrier.titre,
        courrierText: courrier.courrierText,
        isVilleDate: courrier.isVilleDate,
        isNomPatient: courrier.isNomPatient,
        isSelectCorrespondant: courrier.isSelectCorrespondant,
        isImpressionPatient: courrier.isImpressionPatient,
        isEnteteVide: courrier.isEnteteVide,
        isPiedVide: courrier.isPiedVide,
        isDuplicata: courrier.isDuplicata,
        logs: courrier.logs,
        annuleEtRemplace: courrier.annuleEtRemplace,
        versionCourrier: courrier.versionCourrier,
        retenueEnvoiDmp: courrier.retenueEnvoiDmp,
        motifRetenueEnvoiDmp: courrier.motifRetenueEnvoiDmp,
        idTexteModele: courrier.idTexteModele,
      };
    };

    const isCourrierToEditSame = (originalCourrier: CreateCourrier, newCourrier: CreateCourrier): boolean => {
      return originalCourrier.courrierText === newCourrier.courrierText
        && originalCourrier.titre === newCourrier.titre;
    };

    this.courrierForm.markAllAsTouched();

    if (this.courrierForm.valid) {
      let isUpdate: boolean;
      if (this.courrierToEdit) {
        isUpdate = true;
      } else if (this.newCourrier) {
        isUpdate = false;
      }

      let newCourrier: CreateCourrier;

      const editorHtml = this.editorInstance?.html?.get();
      const sizeInBytes = new TextEncoder().encode(editorHtml).length;
      if (sizeInBytes > 2 * 1024 * 1024) {
        this._snakeBarSrv.openSnackBarError('Le contenu du courrier dépasse 2 Mo et ne peut pas être enregistré.');
        return;
      }

      if (isUpdate === true || isUpdate === false) {
        newCourrier = await _getNewCourrier(isUpdate);
      }

      if (newCourrier.courrierText === ''
        || newCourrier.courrierText === '<p><br></p>'
        || newCourrier.courrierText === '<p></p>') {
        /**
         * Si on arrive ici, on considère que le courrier est vide.
         * Dans ce cas on enregistre rien et on affiche un message à l'utilisateur
         */
        this._snakeBarSrv.openSnackBar('Le courrier est vide, il ne sera pas sauvegardé.')
        return;
      }

      if (isUpdate === true && newCourrier) {
        // Extraire les IDs des pièces jointes manuelles
        const annexes = this.manualAttachments.map(att => att.title);
        await this._courrier.update(newCourrier, this.courrierToEdit.id, annexes)
       
          try {
            await this._autoSendDmp(this.courrierToEdit.id, newCourrier);
          } catch (e) {
            this._snakeBarSrv.openSnackBarError("L'envoi au DMP a échoué. Veuillez vérifier que votre cadre d'exercice est renseigné dans les paramètres. Le processus va tout de même continuer.");
          }
          // try {
          //   await this._autoSendMssPatient(this.courrierToEdit.id, newCourrier);
          // } catch (e) {
          //   this._snakeBarSrv.openSnackBarError("L'envoi MSS a échoué. Le processus va tout de même continuer.");
          // }
        

      } else if (isUpdate === false && newCourrier) {
        // Extraire les IDs des pièces jointes manuelles
        const annexes = this.manualAttachments.map(att => att.title);
        const c = await this._courrier.create(newCourrier, this.newCourrier.idConsultation, annexes);
        try {
          await this._autoSendDmp(c.id, newCourrier);
        } catch (e) {
          this._snakeBarSrv.openSnackBarError("L'envoi au DMP a échoué. Veuillez vérifier que votre cadre d'exercice est renseigné dans les paramètres. Le processus va tout de même continuer.");
        }
        // try {
        //   await this._autoSendMssPatient(c.id, newCourrier);
        // } catch (e) {
        //   this._snakeBarSrv.openSnackBarError("L'envoi MSS a échoué. Le processus va tout de même continuer.");
        // }
        this.courrierToEdit = c;
      }

      this._snakeBarSrv.openSnackBar('Le courrier a bien été enregistré.')
    }
    if(saveAndClose === true){
      this.closeAddEditModal()
    }
  }

  async dropped(event: any) {
    const autoRep = this.autoReplaceBodyTable.objects[event.previousIndex];
    if (autoRep.isFunction) {
      if (this.tableName === "dossierPatient" && autoRep.quickKey === "ConsultationsPatient") {


        const ar = await this._replace.findOnePatientByNameAndKey(this.tableName, autoRep.quickKey, this.paitentId);
        if (ar?.note) {
          autoRep.note = ar.note;
        } else {
          autoRep.note = `${autoRep.quickKey}`;
        }

        const modalSelect = this._modal.openModalSelectConsultation(this._view, JSON.parse(autoRep.note) as Consultation[]);
        const subService = this._modal.closeEmitter.subscribe(async response => {
          if (response.object && (response.object as VisualisationConsultation[]).length > 0) {
            if (response?.object) {
              response.object.cartouchePatientVisible = true;
            }
            autoRep.note = await this._consult.visualisation(response.object);
            this.matchesAndTexte(autoRep);
            this._modal.close(modalSelect);
            subService.unsubscribe();
          } else {
            this._modal.close(response.fragment);
            subService.unsubscribe();
          }
        })
      } else {
        let newStr = `${autoRep.quickKey}`;
        let ar: Autoreplace;
        switch (newStr) {
          case "DateConsultation":
            ar = await this._replace.findOnePatientByNameAndKey(this.tableName, autoRep.quickKey, this.consultId);
            break;
          default: {
            ar = await this._replace.findOnePatientByNameAndKey(this.tableName, autoRep.quickKey, this.paitentId);
            break;
          }
        }

        if (ar?.note) {
          newStr = ar.note;
        }
        autoRep.note = newStr;
        this.matchesAndTexte(autoRep);
      }
    } else {
      this.matchesAndTexte(autoRep);
    }

  }

  async matchesAndTexte(autoRep: Autoreplace) {
    let texte = autoRep.note;

    //replace variables
    if (this.tableName === "glossaire" || this.tableName === "penseBete" || this.tableName === "courrierPerso") {
      let regex = /\@.*?\@/gim;

      let matches = texte.match(regex);
      if (!matches) {
        matches = [texte];
      }

      let matchesWord: string[] = [];
      for (let word of matches) {
        const wordWoutAt = word.includes('@') ? word.split('@')[1] : word;
        const nameKey = wordWoutAt.split('.');

        let newStr = `${autoRep.quickKey} `;
        const ar = await this._replace.findPatientListByName(this.tableName, this.paitentId);
        for (let a of ar) {
          if (a.note === matches[0]) {
            newStr = a.note
          }


          matchesWord.push(newStr);
        }
      }


      let i = 0;
      texte = texte.replace(regex, val => {
        const result = matchesWord[i];
        i++;
        return result;
      });
    }

    this.editorInstance.html.insert(texte);
  }



  async changeTable(tableInfo: string) {
    const tableTitles = {
      tag: 'tag',
      glossaire: 'Glossaire',
      penseBete: 'Pense-bêtes',
      maquette: 'Maquettes',
      critere: 'Critères',
      dossierPatient: 'Dossier patient',
      courrierPerso: 'Courriers personnalisés',
      medicamentLibre: 'Médicaments saisie libre'
    };

    if (!tableTitles[tableInfo]) {
      console.error('Le nom de la colonne n\'existe pas.');
      return;
    }

    this.searchInput.searchInput = '';

    this.tableName = tableInfo;

    this.autoReplaceColumnTable[0].title = tableTitles[tableInfo];
    this.autoReplaceBodyTable.objects = await this.getListByName(tableInfo);
    this.toggleTab(tableInfo);
    this._initialAutoReplaceArray = this.autoReplaceBodyTable.objects;
  }


  public toggleTab(tabName: string) {
    this.isTag = false;
    this.isGlossaire = false;
    this.isPenseBete = false;
    this.isMaquette = false;
    this.isCriteres = false;
    this.isDossierPatient = false;
    this.isCourrierPerso = false;
    this.isMedicamentLibre = false;

    switch (tabName) {
      case 'tag':
        {
          this.isTag = true;
          break;
        }
      case 'glossaire':
        {
          this.isGlossaire = true;
          break;
        }
      case 'penseBete':
        {
          this.isPenseBete = true;
          break;
        }
      case 'maquette':
        {
          this.isMaquette = true;
          break;
        }
      case 'critere':
        {
          this.isCriteres = true;
          break;
        }
      case 'dossierPatient':
        {
          this.isDossierPatient = true;
          break;
        }
      case 'courrierPerso':
        {
          this.isCourrierPerso = true;
          break;
        }
      case 'medicamentLibre':
        {
          this.isMedicamentLibre = true;
          break;
        }
      default: {
        break;
      }
    }

  }

  public filterAutoreplaceList(needle: string): void {
    const _normalizeStr = (str: string): string => {
      return this._strUtilsSrv.removeAccents(str).toLowerCase();
    };

    if (needle && needle !== '') {
      this.autoReplaceBodyTable.objects = this._initialAutoReplaceArray.filter(a => _normalizeStr(a.quickKey).includes(_normalizeStr(needle)));
    } else {
      this.autoReplaceBodyTable.objects = this._initialAutoReplaceArray;
    }
  }



  public async displayDoctorsNamesModale(cabinetDoctors: Destinataire[]):Promise<string | null>{
        try {
            const doctorsColumnTable = [
                { title: 'Choisir un médecin :', data: 'name', label: 'Nom du Médecin' }
            ];

            const doctorsData = cabinetDoctors.map(doctor => ({
                name: `${doctor.nom} ${doctor.prenom}`,
                id: doctor.id
            }));

            const modale = this._modal.openModalSelectList(
                this._view,
                'Sélection d\'une en-tête médecin',
                doctorsColumnTable,
                doctorsData,
                'Choisir un médecin :'
            );
            modale.instance.validButtonLabel = 'Sélectionner';

            return new Promise<string | null>((resolve, reject) => {
              const sub = modale.instance.closeEmitter.subscribe(async (res) => {
                  let load: ComponentRef<LoadingModalFragment> | undefined;
                  try {
                      if (res) {
                          load = this._modal.openLoading(this._view);
                          resolve(res.id);
                      } else {
                          resolve(null);
                      }
                  } catch (error) {
                      console.error("Erreur lors du traitement :", error);
                      reject(error);
                  } finally {
                      modale.destroy();
                      sub.unsubscribe();
                      if (load) {
                          load.destroy();
                      }
                  }
              });
          });
        } catch (error) {
            console.error("Erreur lors de la récupération des headers :", error);
            return null;
        }

}

 async sendMail() {
     if (!this.courrierForm.valid) {
      this.courrierForm.markAllAsTouched();
      return;
    }
    try{
        this._displayLoading(true);

      this.courrierToEdit.courrierText = this.editorContent || '';
        this.courrierToEdit.isVilleDate = this.courrierForm.get('isVilleDate')?.value;
        this.courrierToEdit.isNomPatient = this.courrierForm.get('isNomPatient')?.value;
        this.courrierToEdit.isSelectCorrespondant = this.courrierForm.get('isSelectCorrespondant')?.value;
        this.courrierToEdit.isImpressionPatient = this.courrierForm.get('isImpressionPatient')?.value;
        this.courrierToEdit.isEnteteVide = this.courrierForm.get('isEnteteVide')?.value;
        this.courrierToEdit.isPiedVide = this.courrierForm.get('isPiedVide')?.value;
        this.courrierToEdit.isDuplicata = this.courrierForm.get('isDuplicata')?.value;

        // Extraire toutes les annexes des liens (imagerie + documents sélectionnés)
        const { originalHtml, annexes } = await this.expandImageLinks(this.courrierToEdit.courrierText);
        
        // Créer une copie du courrier avec le HTML original (sans les images ajoutées)
        const courrierWithOriginalText = { ...this.courrierToEdit };
        courrierWithOriginalText.courrierText = originalHtml;
        
        let displayInstance: ComponentRef<DisplayDocumentComponent>;

        if (this.choisirEnteteParam === true ) {
         // Pour l'en-tête personnalisée, on doit passer le courrier avec images développées
          const tempCourrier = this.courrierToEdit;
          this.courrierToEdit = courrierWithOriginalText;
          displayInstance = await this.chooseADoctorHeader(true, annexes);
          this.courrierToEdit = tempCourrier; // Restaurer le courrier original
        } else {
          displayInstance = await this._displayDocumentSrv.displayDocument(
            this._view,
            await this._displayDocumentSrv.courrierToDisplayContentData(
              courrierWithOriginalText,
              this.paitentId,
              null,
              this.selectBodyTable.objects,
              undefined, // doctorId
              annexes // Liste des annexes à imprimer séparément
            )
          ) as ComponentRef<DisplayDocumentComponent>;

            displayInstance.instance.isMail = true;
            displayInstance.instance.typeDocument = this.courrierForm.get('typeDocument')?.value || this.typeDocument;
            if (this.courrierToEdit.idTexteModele) {
              displayInstance.instance.idTexteModele = this.courrierToEdit.idTexteModele;
            }
        }
    const sub = displayInstance.instance.closeEmitter.subscribe(event => {
        if (event?.type === 'quickSendDone') {
          this.closeAddEditModal();
          sub.unsubscribe();
        }
      });
    }catch (error) {
      console.error("Erreur lors de l'envoi du mail :", error);
      this._snakeBarSrv.openSnackBarError("Une erreur est survenue lors de l'envoi du mail.");
    }finally{
      this._displayLoading(false);
    }

  }

 async chooseADoctorHeader(isMail?: boolean,annexes?: any[]): Promise<ComponentRef<DisplayDocumentComponent>> {
  const cabinetProfessionnals: Destinataire[] = await this._cabinet.findCurrentCabinetProfils();
  const cabinetDoctors: Destinataire[] = cabinetProfessionnals.filter(pro => pro.qualite !== "Secrétariat médical");

  let doctorId: string | undefined;

  if (cabinetDoctors.length > 1) {
    doctorId = await this.displayDoctorsNamesModale(cabinetDoctors);
    if (!doctorId) {
      this._snakeBarSrv.openSnackBar("Veuillez sélectionner un médecin pour continuer.");
      throw new Error("Médecin non sélectionné");
    }
  } else if (cabinetDoctors.length === 1) {
    doctorId = cabinetDoctors[0].id;
  }

  const displayDocumentInstance = await this._displayDocumentSrv.displayDocument(
    this._view,
    await this._displayDocumentSrv.courrierToDisplayContentData(
      this.courrierToEdit,
      this.paitentId,
      null,
      this.selectBodyTable.objects,
      doctorId,
      annexes
    )
  ) as ComponentRef<DisplayDocumentComponent>;

  if (isMail) {
    displayDocumentInstance.instance.isMail = true;
    displayDocumentInstance.instance.typeDocument = this.courrierForm.get('typeDocument')?.value || this.typeDocument;

    if (this.courrierToEdit.idTexteModele) {
      displayDocumentInstance.instance.idTexteModele = this.courrierToEdit.idTexteModele;
    }
  }
          return displayDocumentInstance;
}


  /**
   * Parse le HTML pour extraire tous les liens d'imagerie
   * @param html Le contenu HTML à parser
   * @returns Un tableau d'objets contenant les informations des liens d'imagerie
   */
  private parseImagerieLinks(html: string): { 
    documentId: string; 
    type: string; 
    fullLinkHtml: string; 
    fileName?: string;
    source?: 'patient' | 'user';
    size?: number;
  }[] {
    const links: { 
      documentId: string; 
      type: string; 
      fullLinkHtml: string; 
      fileName?: string;
      source?: 'patient' | 'user';
      size?: number;
    }[] = [];
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    // Trouver tous les liens avec la classe 'imagerie-link'
    const imagerieLinkElements = doc.querySelectorAll('a.imagerie-link');
    
    imagerieLinkElements.forEach((link) => {
      const documentId = link.getAttribute('data-imagerie-id');
      const type = link.getAttribute('data-type');
      const source = link.getAttribute('data-source') as 'patient' | 'user' || 'patient';
      const sizeStr = link.getAttribute('data-size');
      const size = sizeStr ? Number(sizeStr) : 0;

      // Extraire le nom du fichier depuis le texte du lien
      const fileName = link.textContent?.trim().replace(/^Image\/PDF:\s*/, '').replace(' (Télécharger)', '') || 'Fichier sans nom';
      
      if (documentId && type) {
        links.push({
          documentId,
          type,
          fullLinkHtml: link.outerHTML,
          fileName,
          source,
          size
        });
      }
    });
    return links;
  }

  /**
   * Télécharge une image via son documentId
   * @param id L'id du document à télécharger
   * @returns Le contenu base64 du document avec son type MIME
   */
  private async downloadDocumentById(id: string): Promise<{ payload: string; contentType: string }> {
    try {
      const document = await this._documentSrv.downloadDocument(id);
      return {
        payload: document.payload,
        contentType: document.contentType
      };
    } catch (error) {
      console.error(`Erreur lors du téléchargement de l'image ${id}:`, error);
      throw error;
    }
  }

  /**
   * Parse les liens d'imagerie et télécharge uniquement les documents imprimables (images/PDF)
   * @param html Le contenu HTML contenant les liens d'imagerie
   * @returns Un objet avec le HTML original et la liste des annexes à imprimer
   */
  private async expandImageLinks(html: string): Promise<{ originalHtml: string; annexes: Annexe[] }> {
   
    const links = this.parseImagerieLinks(html);
    
    if (links.length === 0 && this.manualAttachments.length === 0) {
      return { originalHtml: html, annexes: [] }; // Pas de liens à traiter
    }

    const annexes: Annexe[] = [];
    const addedIds = new Set<string>(); // Utiliser un Set pour éviter les doublons par ID
    
    // Télécharger uniquement les images et PDF pour l'impression
    for (let i = 0; i < links.length; i++) {
      const link = links[i];
      const contentType = link.type; 
      
      // Éviter les doublons si le même lien est présent plusieurs fois dans l'éditeur
      if (addedIds.has(link.documentId)) {
        continue;
      }

      // Filtrer pour ne télécharger que les images et les PDF
      if (contentType?.startsWith('image/') || contentType === 'application/pdf') {
        try {
          let payload: string;
          
          // Utiliser le bon service selon la source du document
          if (link.source === 'user') {
            const doc = await this._userDocumentSrv.downloadUserDocument(link.documentId);
            payload = doc.payload;
          } else {
            const doc = await this.downloadDocumentById(link.documentId);
            payload = doc.payload;
          }
          
          annexes.push({
            fileName: link.fileName || `Document ${i + 1}`,
            contentType: contentType,
            base64Data: payload,
            size: link.size
          });
          addedIds.add(link.documentId); // Marquer cet ID comme ajouté
        } catch (error) {
          console.error(`Impossible de télécharger le document ${link.documentId}:`, error);
          this._snakeBarSrv.openSnackBarError(`Impossible de télécharger l'annexe "${link.fileName || 'Document ' + (i + 1)}"`);
        }
      } else {
        if (contentType) {
          this._snakeBarSrv.openSnackBarError(`Impossible d'imprimer l'annexe, vous pouvez la télécharger pour l'imprimer en dehors du courrier "${link.fileName || 'Document ' + (i + 1)}"`);
        }
      }
    }
    
    // Ajouter les pièces jointes manuelles (via bouton trombone)
    // On ne les ajoute que si l'option de sauvegarde avec le courrier est DÉSACTIVÉE
    // Sinon, seuls les liens présents dans l'éditeur font foi (gestion directe dans l'éditeur)
    if (!this.saveAttachmentsWithCourrier) {
      for (const attachment of this.manualAttachments) {
        // Éviter d'ajouter à nouveau si déjà présent via les liens HTML (sécurité supplémentaire)
        if (addedIds.has(attachment.id)) {
          continue;
        }
        
        // Filtrer : ne prendre que les images et PDFs
        const contentType = attachment.contentType || '';
        const isImageOrPdf = contentType.startsWith('image/') || contentType === 'application/pdf';
        
        if (!isImageOrPdf) {
          continue; // Ignorer les documents non compatibles
        }
        
        try {
          let payload: string;
          const source = attachment.source || 'patient';
                    
          if (source === 'user') {
            const doc = await this._userDocumentSrv.downloadUserDocument(attachment.id);
            payload = doc.payload;
          } else {
            const doc = await this.downloadDocumentById(attachment.id);
            payload = doc.payload;
          }
                    
          const annexe = {
            fileName: attachment.title,
            contentType: attachment.contentType || 'application/octet-stream',
            base64Data: payload,
            size: attachment.size
          };
                    
          annexes.push(annexe);
          addedIds.add(attachment.id); // Marquer l'ID au cas où il y aurait des doublons dans manualAttachments
        } catch (error) {
          console.error(`[ERROR] Impossible de télécharger la pièce jointe ${attachment.id}:`, error);
          this._snakeBarSrv.openSnackBarError(`Impossible de télécharger "${attachment.title}"`);
        }
      }
    }    
    return { originalHtml: html, annexes };
  }


  async previewCourrier() {
    // Vérification de la validité du formulaire
    if (!this.courrierForm.valid) {
      this.courrierForm.markAllAsTouched();
      return;
    }

    try{
     this._displayLoading(true);
        this.courrierToEdit.courrierText = this.editorContent || '';
        this.courrierToEdit.isVilleDate = this.courrierForm.get('isVilleDate')?.value;
        this.courrierToEdit.isNomPatient = this.courrierForm.get('isNomPatient')?.value;
        this.courrierToEdit.isSelectCorrespondant = this.courrierForm.get('isSelectCorrespondant')?.value;
        this.courrierToEdit.isImpressionPatient = this.courrierForm.get('isImpressionPatient')?.value;
        this.courrierToEdit.isEnteteVide = this.courrierForm.get('isEnteteVide')?.value;
        this.courrierToEdit.isPiedVide = this.courrierForm.get('isPiedVide')?.value;
        this.courrierToEdit.isDuplicata = this.courrierForm.get('isDuplicata')?.value;
        
        // Séparer le courrier original et les annexes
        const { originalHtml, annexes } = await this.expandImageLinks(this.courrierToEdit.courrierText);
        
        // Créer une copie du courrier avec le HTML original (sans les images ajoutées)
        const courrierWithOriginalText: Courrier = { ...this.courrierToEdit };
        courrierWithOriginalText.courrierText = originalHtml;
        
        let displayInstance: ComponentRef<DisplayDocumentComponent>;

        if (this.choisirEnteteParam === true ) {
          const tempCourrier = this.courrierToEdit;
          this.courrierToEdit = courrierWithOriginalText;
          displayInstance = await this.chooseADoctorHeader(false, annexes);
          this.courrierToEdit = tempCourrier; 
        } else {
          displayInstance = await this._displayDocumentSrv.displayDocument(
            this._view,
            await this._displayDocumentSrv.courrierToDisplayContentData(
              courrierWithOriginalText,
              this.paitentId,
              null,
              this.selectBodyTable.objects,
              undefined, 
              annexes
            )
          ) as ComponentRef<DisplayDocumentComponent>;
        }

        displayInstance.onDestroy(() => {
          this.closeAddEditModal();
        });
    } catch (error) {
      console.error("Erreur lors de la prévisualisation du courrier :", error);
      this._snakeBarSrv.openSnackBarError("Sauvegardez le courrier une première fois pour pouvoir l'imprimer.");
    }finally{
      this._displayLoading(false);
    }

}



addAld() {
  const editor = this.editorInstance;
  if (!editor) return;
  const before = "<p style=\"text-align:center\">________________________________________________________________________________</p><p style=\"text-align:center\"><br></p><p style=\"text-align:center\">Prescriptions relatives au traitement de l'affection de longue durée reconnue</p><p style=\"text-align:center\">(liste ou hors liste)&nbsp;(AFFECTION EXONERANTE)</p><p style=\"text-align:center\">________________________________________________________________________________</p><p style=\"text-align:center\"><br>"
  const after = "<p><br></p><p style=\"text-align:center\">________________________________________________________________________________</p><p style=\"text-align:center\"><br></p><p style=\"text-align:center\">Prescriptions SANS RAPPORT avec l'affection de longue durée</p><p style=\"text-align:center\">(MALADIES INTERCURRENTES)</p><p style=\"text-align:center\">________________________________________________________________________________</p><p><br></p>"
  let selHtml = '';

  if (editor.selection.isCollapsed()){ // on a pas de selection
    // HTML exact de la sélection (avec mise en forme)
    selHtml = '<p><br></p>';
    // Remplace la sélection par le nouveau contenu
    editor.html.insert(`${before}${selHtml}${after}`);
    return;
  } else { // on a une selection
    // HTML exact de la sélection (avec mise en forme)
    selHtml = editor.html.getSelected() || '';
    // Remplace la sélection par le nouveau contenu
    editor.html.insert(`${before}${selHtml}${after}`);
  }
  // editor.html.insert(this.TEXT_ALD_ENCART);
}

public async rechercheSemantique(): Promise < void> {
  const result = await this._searchRefSrv.initRecherche(this._view, [ReferentielType.ccam, ReferentielType.produitMed, ReferentielType['cim-10']]);
  this.editorInstance.html.insert(result.libelle);
}


async addCorrespondant() {
  const modalRef: ComponentRef<AddCorrespondantInEditorComponent> = await this._modal.openModalCorrespondantInEditor(this._view, this.selectBodyTable.objects);

  modalRef.instance.correspondantsUpdated.subscribe((updatedCorrespondants: Correspondant[]) => {
    this.selectBodyTable.objects = updatedCorrespondants;
  });
}

  async getListByName(name: string): Promise < Autoreplace[] > {
  return await this._replace.findByName(name);
}


async saveThenPrint() {
  this._displayLoading(true);
  try{
    await this.saveCourrier(false);
    await this.previewCourrier();
  }catch (error) {
  console.error("Erreur lors de l'enregistrement et de l'impression :", error);
  this._snakeBarSrv.openSnackBarError('Erreur lors de l\'enregistrement et de l\'impression du courrier.');
  }finally{
    this._displayLoading(false);
  }
}

async saveThenSendMail() {
  this._displayLoading(true);
  try{
    await this.saveCourrier(false);
    await this.sendMail();
  }catch (error) {
  console.error("Erreur lors de l'enregistrement et de l'envoi par mail :", error);
  this._snakeBarSrv.openSnackBarError('Erreur lors de l\'enregistrement et de l\'envoi par mail du courrier.');
  }finally{
    this._displayLoading(false);
  }
}

/**
 * Attache les gestionnaires de clics pour les liens d'imagerie dans l'éditeur Froala
 */
private attachEditorLinkHandlers(): void {
  if (!this.editorInstance) {
    console.warn('Éditeur Froala non initialisé');
    return;
  }
  
  try {
    // Récupérer l'élément DOM de l'éditeur
    const editorElement = this.editorInstance.$el?.[0];
    if (!editorElement) {
      console.warn('Élément DOM de l\'éditeur introuvable');
      return;
    }
    
    // Utiliser la délégation d'événements pour gérer les clics sur les liens
    editorElement.addEventListener('click', (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      
      // Vérifier si l'élément cliqué est un lien d'imagerie ou un enfant d'un lien d'imagerie
      const link = target.closest('a.imagerie-link') as HTMLAnchorElement;
      
      if (link) {
        // Intercepter tous les clics sur les liens d'imagerie
        event.preventDefault();
        event.stopPropagation();
        this.handleEditorLinkClick(link);
      }
    });
  } catch (error) {
    console.error('Erreur lors de l\'attachement des handlers:', error);
  }
}

/**
 * Gère le clic sur un lien d'imagerie dans l'éditeur
 * @param link L'élément lien cliqué
 */
private async handleEditorLinkClick(link: HTMLAnchorElement): Promise<void> {
  const documentId = link.getAttribute('data-imagerie-id');
  const contentType = link.getAttribute('data-type'); // Utiliser data-type du backend
  const source = link.getAttribute('data-source') || 'patient'; // 'patient' ou 'user'
  const fileName = link.textContent?.trim().replace(' (Télécharger)', '') || 'Document';
  
  if (!documentId) {
    console.error('ID du document manquant sur le lien d\'imagerie');
    return;
  }
  
  if (!contentType) {
    console.error('Type de contenu manquant sur le lien d\'imagerie');
    return;
  }
  
  // Télécharger le document à la demande (lors du clic)
  let filePayload: string;
  try {
    if (source === 'user') {
      // Pour les documents utilisateurs
      const doc = await this._userDocumentSrv.downloadUserDocument(documentId);
      filePayload = doc.payload;
    } else {
      // Pour les documents patient
      const doc = await this.downloadDocumentById(documentId);
      filePayload = doc.payload;
    }
  } catch (error) {
    console.error('Erreur lors du téléchargement du document:', error);
    this._snakeBarSrv.openSnackBarError(`Impossible de charger le document "${fileName}"`);
    return;
  }
  
  // Vérifier si le fichier est compatible (image ou PDF)
  const isCompatible = contentType.startsWith('image/') || contentType === 'application/pdf';
  
  if (isCompatible) {
    // Ouvrir en aperçu
    try {
      const displayData: DisplayContentData = {
        id: documentId,
        title: fileName,
        fileName: fileName,
        contentType: contentType,
        date: new Date(),
        data: DocumentService.prefixBase64(filePayload, contentType),
        dataPrint: ''
      };
      
      await this._displayDocumentSrv.displayDocument(this._view, displayData);
    } catch (error) {
      console.error('Erreur lors de l\'ouverture de l\'aperçu:', error);
      this._snakeBarSrv.openSnackBarError(`Erreur lors de l'ouverture de "${fileName}"`);
    }
  } else {
    // Télécharger le fichier
    try {
      const base64WithPrefix = DocumentService.prefixBase64(filePayload, contentType);
      const response = await fetch(base64WithPrefix);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Erreur lors du téléchargement:', error);
      this._snakeBarSrv.openSnackBarError(`Erreur lors du téléchargement de "${fileName}"`);
    }
  }
}

/**
 * Ouvre la modale de sélection de documents pour ajouter une pièce jointe manuelle
 */
public async addPieceJointe() {
  const modal = this._modal.openModalSelectDocument(
    this._view,
    this.paitentId,
    this.consultId
  );
  
  // S'abonner à la sélection de documents
  const docSelected = modal.instance.documentSelected.subscribe((docs: any) => {
    const docArray = Array.isArray(docs) ? docs : [docs];
    
    docArray.forEach(doc => {
      // Ajouter à la liste des pièces jointes manuelles au lieu d'insérer dans l'éditeur
      this.addToManualAttachments(doc);
    });
    
    modal.destroy();
    docSelected.unsubscribe();
  });
  const closeEmitter = modal.instance.closeEmitter.subscribe(async (res) => {
    modal.destroy();
    closeEmitter.unsubscribe();
  });
}

/**
 * Ajoute un document à la liste des pièces jointes manuelles
 */
private addToManualAttachments(doc: any) {
  // Vérifier que le document n'est pas déjà dans la liste
  if (!this.manualAttachments.find(a => a.id === doc.id)) {
    this.manualAttachments.push(doc);
    // Auto-insertion si l'option est active
    if (this.saveAttachmentsWithCourrier) {
      this.insertManualAttachmentsInEditor();
    }
  }
}

/**
 * Retire une pièce jointe de la liste et supprime son lien de l'éditeur
 */
public removeManualAttachment(docId: string) {
  const index = this.manualAttachments.findIndex(a => a.id === docId);
  if (index > -1) {
    this.manualAttachments.splice(index, 1);
    
    // Supprimer également le lien de l'éditeur s'il existe
    if (this.editorInstance) {
      const currentHtml = this.editorInstance.html.get();
      // Chercher et supprimer le lien avec cet ID
      const regex = new RegExp(`<a[^>]*data-imagerie-id="${docId}"[^>]*>.*?</a>\\s*<br>\\s*`, 'g');
      const newHtml = currentHtml.replace(regex, '');
      if (newHtml !== currentHtml) {
        this.editorInstance.html.set(newHtml);
      }
    }
  }
}

/**
 * Formate la taille d'un fichier en unités lisibles
 */
public formatFileSize(bytes: number): string {
  if (!bytes) return '';
  
  const sizes = ['octets', 'Ko', 'Mo', 'Go'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  
  if (i === 0) return `${bytes} ${sizes[i]}`;
  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
}


/**
 * Insère tous les attachements manuels comme liens à la fin de l'éditeur
 * Avec une phrase d'introduction et séparés par des virgules
 */
private insertManualAttachmentsInEditor(): void {
  if (!this.editorInstance || this.manualAttachments.length === 0) {
    return;
  }

  // Préparer la phrase d'introduction
  const intro = `Le courrier a été créé le ${moment().format('DD/MM/YYYY')}, par ${this.profil.utilisateur.nom} ${this.profil.utilisateur.prenom} avec les pièces jointes suivantes : `;
  
  // Construire la liste des liens
  let linksHtml = '';
  for (let i = 0; i < this.manualAttachments.length; i++) {
    const attachment = this.manualAttachments[i];
    const contentType = attachment.contentType || '';
    const isImageOrPdf = contentType.startsWith('image/') || contentType === 'application/pdf';
    const displayTitle = isImageOrPdf ? attachment.title : `${attachment.title} (Télécharger)`;
    const source = attachment.source || 'patient';
    const linkHtml = `<a href="#" class="imagerie-link" data-imagerie-id="${attachment.id}" data-type="${contentType}" data-source="${source}" data-size="${attachment.size}">${displayTitle}</a>`;
    const separator = i < this.manualAttachments.length - 1 ? ', ' : '';
    linksHtml += linkHtml + separator;
  }

  // Créer tout le bloc avec une classe spécifique pour un ciblage facile
  const sectionHtml = `<p class="pj-section-in-editor"><br>${intro}${linksHtml}.</p>`;
  
  let currentHtml = this.editorInstance.html.get();
  // Regex plus souple pour trouver la section même si Froala ajoute des styles ou d'autres classes
  const sectionRegex = /<p[^>]*class="[^"]*pj-section-in-editor[^"]*"[^>]*>.*?<\/p>/g;
  
  if (sectionRegex.test(currentHtml)) {
    // Si la section existe déjà, on la remplace (mise à jour de la liste)
    currentHtml = currentHtml.replace(sectionRegex, sectionHtml);
    this.editorInstance.html.set(currentHtml);
  } else {
    // Sinon on l'insère à la fin
    this.editorInstance.selection.setAtEnd(this.editorInstance.$el.get(0));
    this.editorInstance.selection.restore();
    this.editorInstance.html.insert(sectionHtml);
  }
}

/**
 * Supprime tous les liens des attachements manuels de l'éditeur
 */
private removeAllManualAttachmentLinksFromEditor(): void {
  if (!this.editorInstance) {
    return;
  }

  let currentHtml = this.editorInstance.html.get();
  
  // Supprimer tout le bloc identifié par la classe 'pj-section-in-editor'
  // Regex plus souple pour capturer le paragraphe quel que soit ses autres attributs
  const sectionRegex = /<p[^>]*class="[^"]*pj-section-in-editor[^"]*"[^>]*>.*?<\/p>/g;
  currentHtml = currentHtml.replace(sectionRegex, '');
  
  this.editorInstance.html.set(currentHtml);
}

/**
 * Gère le changement d'état de la checkbox "Sauvegarder les PJ avec le courrier"
 */
public onSaveAttachmentsToggle(event: any): void {
  if (this.saveAttachmentsWithCourrier) {
    // Checkbox cochée : insérer les liens immédiatement
    this.insertManualAttachmentsInEditor();
  } else {
    // Checkbox décochée : retirer tous les liens
    this.removeAllManualAttachmentLinksFromEditor();
  }
}

/**
 * Gère le clic sur une pièce jointe manuelle pour la prévisualiser
 * Note: Cette méthode n'est appelée que pour les images et PDFs (filtré dans le HTML)
 */
public async previewManualAttachment(attachment: any) {
  try {
    const source = attachment.source || 'patient';
    const documentId = attachment.id;
    const contentType = attachment.contentType || 'application/octet-stream';
  
    // Télécharger le document
    let doc;
    if (source === 'user') {
      doc = await this._userDocumentSrv.downloadUserDocument(documentId);
    } else {
      doc = await this.downloadDocumentById(documentId);
    }
    const image = doc.contentType.startsWith('image/');
    const pdf = doc.contentType === 'application/pdf';
    if (!image && !pdf) { 
      this._snakeBarSrv.openSnackBarError(`Prévisualisation impossible pour « ${attachment.title} ».
      Téléchargement disponible.
      Formats autorisés : PDF et images.`);
      return;
    }
    // Créer un objet DisplayContentData pour l'affichage (format compatible)
    const displayData: DisplayContentData = {
      id: documentId,
      title: attachment.title,
      fileName: attachment.title,
      contentType: contentType,
      date: new Date(),
      data: DocumentService.prefixBase64(doc.payload, contentType),
      dataPrint: ''
    };
    
    // Afficher dans display-document
    await this._displayDocumentSrv.displayDocument(this._view, displayData);
    
  } catch (error) {
    console.error('Erreur lors de la prévisualisation de la pièce jointe:', error);
    this._snakeBarSrv.openSnackBarError(`Impossible de prévisualiser "${attachment.title}"`);
  }
}

/**
 * Télécharge une pièce jointe manuelle (pour les documents non image/PDF)
 */
public async downloadManualAttachment(attachment: any) {
  try {
    const source = attachment.source || 'patient';
    const documentId = attachment.id;
    const contentType = attachment.contentType || 'application/octet-stream';
    
    // Télécharger le document
    let doc;
    if (source === 'user') {
      doc = await this._userDocumentSrv.downloadUserDocument(documentId);
    } else {
      doc = await this.downloadDocumentById(documentId);
    }
    
    // Télécharger le fichier
    const base64WithPrefix = DocumentService.prefixBase64(doc.payload, contentType);
    const response = await fetch(base64WithPrefix);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = attachment.title;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    
  } catch (error) {
    console.error('Erreur lors du téléchargement de la pièce jointe:', error);
    this._snakeBarSrv.openSnackBarError(`Impossible de télécharger "${attachment.title}"`);
  }
}

/**
 * Vérifie si une pièce jointe est compatible pour la prévisualisation (image ou PDF)
 */
public isAttachmentPreviewable(attachment: any): boolean {
  const contentType = attachment.contentType || '';
  return contentType.startsWith('image/') || contentType === 'application/pdf';
}
}

